module.exports = __webpack_public_path__ + "media/images/emoticons/by-d-a5573ec9cb1741f1b8eb47f89944fd87.gif";